interface Props {
  title?: string;
  balance?: number;
}

export function TwaHeader({ title = "Каталог", balance }: Props) {
  return (
    <div
      className="flex items-center justify-between"
      style={{ padding: "14px 18px" }}
    >
      <h1
        style={{
          color: "var(--color-sk-text)",
          fontSize: 36,
          fontWeight: 400,
          letterSpacing: -0.8,
          fontFamily: "var(--font-sk-display)",
          fontStyle: "italic",
          lineHeight: 1,
          margin: 0,
        }}
      >
        {title}
      </h1>
      {typeof balance === "number" && balance > 0 && (
        <div
          style={{
            background: "var(--color-sk-card)",
            border: "1px solid var(--color-sk-line)",
            padding: "6px 12px",
            borderRadius: 999,
            fontFamily: "var(--font-sk-mono)",
            fontSize: 12,
            fontWeight: 600,
            color: "var(--color-sk-text)",
            whiteSpace: "nowrap",
          }}
        >
          {balance} ✨
        </div>
      )}
    </div>
  );
}
